/**
 * Post-SSO / Change Customer returnUrl must be a storefront page.
 * Identity Server OIDC paths (e.g. /identity/callback, /identity/externalcallback)
 * are not CMS pages — redirecting there shows Page Not Found and an empty header session.
 */
export const isIdentityServerPath = (url?: string): boolean => {
    if (!url) {
        return false;
    }

    const path = (url.split("?")[0] || "").toLowerCase();
    return path === "/identity" || path.startsWith("/identity/");
};

/** Returns a usable storefront returnUrl, or undefined when the value is missing/unsafe. */
export const sanitizePostAuthReturnUrl = (url?: string): string | undefined => {
    if (!url) {
        return undefined;
    }

    if (isIdentityServerPath(url)) {
        return undefined;
    }

    return url;
};
